var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPayrollServices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6425 20.6604H14.7259C14.7827 20.6585 14.8394 20.6686 14.8921 20.69C14.9448 20.7115 14.9924 20.7439 15.0318 20.785C15.0711 20.8262 15.1013 20.8752 15.1204 20.9288C15.1395 20.9824 15.147 21.0395 15.1425 21.0962V28.9379C15.1472 28.9946 15.1397 29.0517 15.1207 29.1054C15.1016 29.159 15.0714 29.208 15.032 29.2491C14.9926 29.2902 14.945 29.3225 14.8922 29.3438C14.8394 29.3652 14.7827 29.3751 14.7259 29.3729H12.6425",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6017 18.82L17 20.8142C16.8948 20.9453 16.7625 21.0521 16.6122 21.1273C16.4619 21.2025 16.2972 21.2444 16.1292 21.25H15.1425M15.1425 27.1083C16.9292 28.4625 18.5592 29.3717 19.6117 29.3717H24.8392C25.4725 29.3717 25.8709 29.3267 26.1459 28.5008C26.5659 26.3925 26.8567 24.2608 27.0175 22.1175C27.0175 21.6825 26.5817 21.2467 25.7109 21.2467H20.7675M18.795 20.1708L17.505 11.1442C17.4958 11.0797 17.5006 11.014 17.519 10.9515C17.5374 10.889 17.569 10.8312 17.6116 10.782C17.6543 10.7328 17.707 10.6933 17.7663 10.6662C17.8255 10.6391 17.8899 10.6251 17.955 10.625H24.25",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5326 21.2496L20.7693 13.6171C20.763 13.5588 20.7692 13.4998 20.7873 13.4441C20.8055 13.3883 20.8352 13.337 20.8745 13.2935C20.9138 13.25 20.9619 13.2153 21.0156 13.1916C21.0692 13.168 21.1273 13.1559 21.1859 13.1563H26.9359C26.9965 13.1556 27.0565 13.168 27.1117 13.1929C27.167 13.2177 27.2161 13.2543 27.2558 13.3C27.2954 13.3458 27.3247 13.3997 27.3414 13.4579C27.3581 13.5161 27.3619 13.5773 27.3526 13.6371L26.2026 21.3038",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9135 17.8086C23.8306 17.8086 23.7511 17.7757 23.6925 17.7171C23.6339 17.6585 23.601 17.579 23.601 17.4961C23.601 17.4132 23.6339 17.3337 23.6925 17.2751C23.7511 17.2165 23.8306 17.1836 23.9135 17.1836M23.9135 17.8086C23.9963 17.8086 24.0758 17.7757 24.1344 17.7171C24.193 17.6585 24.226 17.579 24.226 17.4961C24.226 17.4132 24.193 17.3337 24.1344 17.2751C24.0758 17.2165 23.9963 17.1836 23.9135 17.1836",
    stroke: "white",
    strokeWidth: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPayrollServices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_payroll_services.3843dc20f4fa59e63928251a2cd42854.svg";